import {fetchDashboard, fetchDashboardFailed, fetchDashboardSuccess} from 'modules/actions/dashboard';
import {RequestState} from 'modules/enums';
import {createReducer} from 'redux-act';


interface IDashboardStore {
	dashboard: ReturnType<typeof fetchDashboardSuccess>["payload"];
	requestState: RequestState;
}

const defaultState: IDashboardStore = {
	dashboard: {
		currentStreak: null,
		numberPredictions: 0,
		numberFriendsEntries: 0,
		bestStreak: null,
		nextStreakGoal: null,
		isMulliganUsed: false,
		isMulliganCanBeUsed: false,
		isMulliganAllowed: false,
		isMulliganEnabled: false,
		rank: null,
		accuracy: null,
		percentile: null,
		isTied: null,
	},
	requestState: RequestState.IDLE,
};

export const dashboard = createReducer({}, defaultState)
	.on(fetchDashboard, (state) => ({
		...state,
		requestState: RequestState.REQUESTED,
	}))
	.on(fetchDashboardSuccess, (state, payload) => ({
		...state,
		dashboard: payload,
		requestState: RequestState.RECEIVED,
	}))
	.on(fetchDashboardFailed, (state) => ({
		...state,
		requestState: RequestState.RECEIVED,
	}));
